import React, { PureComponent } from "react";
import DatePicker from "react-datepicker";
import classNames from "classnames";
import NumberFormat from "react-number-format";

import "react-datepicker/dist/react-datepicker.css";

export default class DatePickerIN extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      startDate: this.props.Value ? new Date(this.props.Value) : null,
    };
  }

  handleChange = (date) => {
    if (date === null || date.getFullYear() <= 9999) {
      this.setState({
        startDate: date,
      });
    }
  };

  handleSelect = (value) => {
    if (value) {
      let valueStr = value.toLocaleDateString(undefined, {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });

      this.setState({
        startDate: value,
      });

      this.changeDate(valueStr);
    }
  };

  changeDate(valueStr) {
    if (this.props.Value !== valueStr) {
      this.props.onValueChanged(valueStr);
    }
  }

  componentDidUpdate(prevProps) {
    const date = new Date(this.props.Value);

    if (this.props.Value !== prevProps.Value && this.props.Value == null) {
      this.setState({
        startDate: this.props.Value ? date : null,
      });
    }
  }

  render() {
    let {
      PlaceholderText,
      Width,
      MinDateValue,
      MaxDateValue,
      ValidationMessages,
    } = this.props;
    const inputClass = classNames({
      "form-control": true,
      "is-invalid": ValidationMessages && ValidationMessages.length > 0,
    });
    const finalPlaceholder = PlaceholderText ? PlaceholderText : "MM/DD/YYYY";

    return (
      <div className="date-picker">
        <DatePicker
          autoComplete={"off"}
          placeholderText={finalPlaceholder}
          style={{ width: Width || "280px" }}
          onChange={this.handleChange}
          onSelect={this.handleSelect}
          dateFormat="MM/dd/yyyy"
          minDate={MinDateValue}
          maxDate={MaxDateValue}
          selected={this.state.startDate}
          calendarPlacement={"bottom"}
          id="datepick"
          className={inputClass}
          disabledKeyboardNavigation={true}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          customInput={
            <NumberFormat
              format="##/##/####"
              placeholder="MM/DD/YYYY"
              mask="_"
              style={{ cursor: "pointer" }}
            />
          }
        />
        <div className={inputClass} style={{ display: "none" }} />
      </div>
    );
  }
}
